import { MenuItem } from '@mui/material';
import PropTypes from 'prop-types';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import HelpIcon from '@mui/icons-material/Help';
import VerticalNav from '../components/VerticalNav';
const ServiceDeskButton = ({
  isMobile,
  isJSDLoaded,
  ListItemText,
  ListItemIcon,
}) => {
  const handleServiceDeskClick = () => {
    if (isJSDLoaded) {
      let iframe = document.querySelector('#jsd-widget'); // Get the widget iframe
      if (iframe) {
        let iframeContent =
          iframe.contentDocument || iframe.contentWindow.document; // Get iframe content
        let button = iframeContent.querySelector('#help-button'); // Find the help button
        if (button) {
          button.style.display = 'none'; // Hide the help button
          button.click(); // Click the button
        } else {
          console.error('Help button not found inside the iframe!');
        }
      } else {
        console.error('JSD widget iframe not found!');
      }
    } else {
      console.error('JSD widget is not loaded yet.');
    }
  };
  let supportButton = null;
 const OwnerRoutes = () => [
  {
    id: 'Support',
    title: 'Support',
    messageId: 'Support',
    type: 'action',
    icon: <HelpOutlineOutlinedIcon />,
    action: handleServiceDeskClick,
  },
];
    if (!isMobile) {
      supportButton = (
          <VerticalNav routesConfig={OwnerRoutes()} disabled={!isJSDLoaded} />
      );
    } else {
      supportButton = (
        <MenuItem onClick={handleServiceDeskClick} disabled={!isJSDLoaded}>
          <ListItemIcon sx={{ minWidth: 40 }}>
            <HelpIcon />
          </ListItemIcon>
          <ListItemText primary='Support' />
        </MenuItem>
      );
    }

  return supportButton;
};
ServiceDeskButton.propTypes = {
  AppTooltip: PropTypes.func,
  tooltipPosition: PropTypes.string,
  isMobile: PropTypes.bool,
  isJSDLoaded: PropTypes.bool,
  ListItemIcon: PropTypes.func,
  ListItemText: PropTypes.func,
};
export default ServiceDeskButton;
